import { render, staticRenderFns } from "./tag_row.vue?vue&type=template&id=7aa413ca&lang=pug"
import script from "./tag_row.vue?vue&type=script&lang=js"
export * from "./tag_row.vue?vue&type=script&lang=js"
import style0 from "./tag_row.vue?vue&type=style&index=0&id=7aa413ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports